import { render } from "./telegram.svg?vue&type=template&id=64ee41cd"
const script = {}
script.render = render

export default script